import React, { PropsWithChildren } from 'react';
import classnames from 'classnames';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import './LockLayoutToggle.scss';
import { useToggleLayoutLocked } from 'layout/store/hooks';

type LockToggleProps = PropsWithChildren<unknown>;

export default function LockLayoutToggle(props: LockToggleProps) {
    const { children } = props;

    const { isLocked, toggleLocked } = useToggleLayoutLocked();

    let lockedClassName: 'locked' | 'unlocked';
    let lockedIconName: 'lock' | 'lock open';
    if (isLocked) {
        lockedClassName = 'locked';
        lockedIconName = 'lock';
    } else {
        lockedClassName = 'unlocked';
        lockedIconName = 'lock open';
    }

    return (
        <div className={classnames('LockToggle', lockedClassName)}>
            {children}
            <button className="circle-toggle" onClick={toggleLocked}>
                <div className="circle">
                    <Icon name={lockedIconName} />
                </div>
            </button>
        </div>
    );
}
